import React, { useEffect, useState } from "react";
import UploadHeatingBillView from "./components/UploadHeatingBillView.jsx";
import Error from "../../../shared/components/Error.jsx";
import { withTranslation } from "react-i18next";
import { addToGoogleDataLayer } from "../../../shared/const/utls.js";

const UploadHeatingBill = ({ i18n }) => {
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    try {
      addToGoogleDataLayer("Upload Bill", "HARP Application", i18n.language);
      window.scrollTo(0, 0);
    } catch (e) {
      console.log(e);
    }

    if (i18n?.language === "en") {
      document.title =
        "Upload Heating Bill - HARP - Government of Nova Scotia";
    } else {
      document.title =
        "Télécharger une facture de chauffage – PAC – Gouvernement de la Nouvelle-Écosse";
    }
  }, [i18n.language]);

  return isError ? (
    <Error />
  ) : (
    <UploadHeatingBillView setIsError={setIsError} />
  );
};

export default withTranslation("common")(UploadHeatingBill);
